import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import './styles/index.css';
import './lib/i18n';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfigLoader } from './components/ConfigLoader';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: (failureCount, error) => {
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfigLoader>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster position="top-right" richColors gap={12} expand visibleToasts={5} />
        </QueryClientProvider>
      </ConfigLoader>
    </ErrorBoundary>
  </React.StrictMode>
);

